import { Box, Transition } from '@wix/design-system';
import React from 'react';
import { AltTextScreenTopSection } from './alt-image-screen-top-section/alt-text-screen-top-section';
import { AltTextScreenBottomSection } from './alt-text-screen-bottom-section';
import { AltTextScreenContent } from './alt-text-screen-content/alt-text-screen-content';
export const AltTextScreen = () => {
  return /*#__PURE__*/React.createElement(Transition, {
    animateOnLoad: true,
    enterAnimation: {
      moveIn: {
        direction: 'rightToLeft',
        distance: '300px',
        duration: 'fast01',
        easing: 'enterEasing'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    bottom: "0",
    direction: "vertical",
    height: "100%",
    left: "0",
    position: "absolute",
    right: "0",
    top: "0"
  }, /*#__PURE__*/React.createElement(AltTextScreenTopSection, null), /*#__PURE__*/React.createElement(AltTextScreenContent, null), /*#__PURE__*/React.createElement(AltTextScreenBottomSection, null)));
};
//# sourceMappingURL=alt-text-screen.js.map